import { render } from "./BaseDialog.vue?vue&type=template&id=3ba25979&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=3ba25979&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba25979"]])

export default __exports__